import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import {
  BookOpen,
  Moon,
  Stethoscope,
  Sparkles,
  Baby,
  ShieldCheck,
  Check,
} from "lucide-react";
import { MODULES } from "./data";
import { LANDING } from "@/constants/testIds";

const ICONS = { BookOpen, Moon, Stethoscope, Sparkles, Baby, ShieldCheck };

export default function DeliverablesSection() {
  return (
    <section id="entregaveis" className="py-28 bg-[#2d1f43] relative overflow-hidden">
      <div className="absolute inset-0 stars-bg opacity-20 pointer-events-none" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center max-w-3xl mx-auto mb-14"
        >
          <h2 className="font-display text-4xl lg:text-[52px] text-white leading-[1.1]">
            A Jornada por dentro:
            <span className="block text-[#a78bfa] font-medium mt-2">
              6 módulos · 21 aulas em vídeo
            </span>
            <span className="block text-[#a78bfa] font-medium">
              em ordem de aplicação.
            </span>
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3">
          {MODULES.map((m, i) => {
            const Icon = ICONS[m.icon] || Moon;
            return (
              <AccordionItem
                key={m.n}
                value={`module-${m.n}`}
                data-testid={LANDING.deliverablesModule}
                className="rounded-3xl border border-white/10 bg-gradient-to-br from-white/[0.04] to-transparent backdrop-blur-sm overflow-hidden hover:border-violet-400/30 transition-colors duration-500"
              >
                <AccordionTrigger className="px-6 lg:px-8 py-6 hover:no-underline group">
                  <div className="flex items-start gap-5 text-left w-full">
                    {/* Icon */}
                    <div className="w-12 h-12 rounded-2xl bg-violet-400/15 flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-6 h-6 text-[#6d28d9]" strokeWidth={1.5} />
                    </div>
                    {/* Number + Title + Description */}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-3 mb-2 h-5">
                        <span className="font-display text-2xl text-[#6d28d9]/50 leading-none">
                          {m.n}
                        </span>
                        <span className="text-[10px] uppercase tracking-[0.22em] text-[#a78bfa]/70 font-bold">
                          Módulo
                        </span>
                      </div>
                      <h3 className="font-display text-xl lg:text-2xl text-white leading-tight mb-2 min-h-[2rem]">
                        {m.title}
                      </h3>
                      <p className="text-slate-300/75 text-sm leading-relaxed font-light">
                        {m.description}
                      </p>
                    </div>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-6 lg:px-8 pb-7">
                  <div className="ml-0 lg:ml-[68px] pl-0 lg:pl-5 lg:border-l lg:border-violet-400/20">
                    <p className="text-[11px] uppercase tracking-[0.2em] text-[#6d28d9] font-bold mb-4">
                      Aulas deste módulo
                    </p>
                    <ul className="space-y-3">
                      {m.learnings.map((l, idx) => (
                        <li
                          key={idx}
                          className="flex gap-3 text-slate-200/90 text-[15px] leading-relaxed"
                        >
                          <Check
                            className="w-4 h-4 text-[#6d28d9] shrink-0 mt-1"
                            strokeWidth={2.5}
                          />
                          <span>{l}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </section>
  );
}
